import React from "react";

// SVG marker for Afval Eiland, scaled to 7x12 px, original colors
const AfvalEilandMarkerSVG = ({ x, y }) => (
  <g transform={`translate(${x - 15}, ${y - 15})`}>
    <svg
      width={30}
      height={30}
      viewBox="0 0 609.45 708.66"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      <g>
        <rect fill="#376eb5" y="423.47" width="283.46" height="283.46" />
        <rect fill="#1d1d1b" x="325.98" y="423.47" width="283.46" height="283.46" />
        <rect fill="#646363" x="283.46" width="42.52" height="708.66" />
      </g>
    </svg>
  </g>
);

export default AfvalEilandMarkerSVG;
